import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "app/store";

const selectPricingValuesState = (state: RootState) => state.pricingValues
// Sélecteurs
export const selectVariableValues = (state: RootState) => state.pricingValues.globalVariablesValues;
export const selectFeeValues = (state: RootState) => state.pricingValues.globaleFeeValues;
export const selectVariableValue = (id: string) => (state: RootState) =>
  state.pricingValues.globalVariablesValues[id];
export const selectFeeValue = (id: string) => (state: RootState) =>
  state.pricingValues.globaleFeeValues[id];
export const selectIsUpdatingPrices = (state: RootState) => state.pricingValues.isUpdatingPrices;
export const selectPricingError = (state: RootState) => state.pricingValues.error;

// Sélecteur pour obtenir toutes les valeurs formatées pour l'API
// Fees: only those changed in the panel, compared by code with the value received in the sidebar
// (the server matches them by nature code and rewrites each one as a fixed amount excluding tax).
export const selectAllValuesForAPI = createSelector(
  [selectPricingValuesState],
  (pricingState) => ({
    variables: Object.entries(pricingState.globalVariablesValues).map(([idReferentialVariable, value]) => ({
      idReferentialVariable,
      value
    })),
    fees: Object.entries(pricingState.globaleFeeValues)
      .filter(([code, value]) => pricingState.fees.find((fee) => fee.code === code)?.value !== value)
      .map(([code, value]) => ({
        code,
        value
      }))
  })
);

export const selectVariables = createSelector(
  [selectPricingValuesState],
  (pricingState) => pricingState.variables
)

export const selectFees = createSelector(
  [selectPricingValuesState],
  (pricingState) => pricingState.fees
)
